// import axios from "axios";
import { makeBrowserDownload } from "./download";

const LOCAL_MOCK_PDF_PATH = "/dev/mock.pdf";
const MOCK_PDF_LOAD_DELAY_SECONDS = 3;
const DEFAULT_MOCK_CONTENT_TYPE = "application/pdf";

const isLocalhost = () =>
  typeof window !== "undefined" && ["localhost", "127.0.0.1"].includes(window.location.hostname);

const isPdfUrl = (url) => /\.pdf$/i.test(url);

const delay = (seconds) =>
  new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });

const shouldUseLocalMockPdf = (url) => isLocalhost() && isPdfUrl(url);

const loadLocalMockPdf = async (filename) => {
  if (MOCK_PDF_LOAD_DELAY_SECONDS > 0) {
    await delay(MOCK_PDF_LOAD_DELAY_SECONDS);
  }

  const response = await fetch(LOCAL_MOCK_PDF_PATH);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch local mock PDF at ${LOCAL_MOCK_PDF_PATH}. ` +
        `Place your PDF file at public/dev/mock.pdf for local development. ` +
        `(${response.status} - ${response.statusText})`
    );
  }

  const contentType = response.headers.get("content-type") || DEFAULT_MOCK_CONTENT_TYPE;
  const fileBlob = await response.blob();
  const file = new File([fileBlob], filename, { type: contentType });

  return {
    file,
    downloadInfo: [fileBlob, filename, contentType],
  };
};

export const isLocalDevHost = isLocalhost;

/** Fetch public/dev/mock.pdf for local testing (served at /dev/mock.pdf). */
export const fetchLocalMockPdf = (filename = "mock.pdf") => loadLocalMockPdf(filename);

export const getStaticFile = async (url) => {
  const filename = url.split("/").pop();

  if (shouldUseLocalMockPdf(url)) {
    return loadLocalMockPdf(filename);
  }

  const response = await fetch(`/static${url}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch the file: ${response.status} - ${response.statusText}`);
  }

  const contentType = response.headers.get("content-type");
  const fileBlob = await response.blob();
  const fileFile = new File([fileBlob], filename, { type: contentType });

  return {
    file: fileFile,
    downloadInfo: [fileBlob, filename, contentType],
  };
};

// export const getStaticFile = async (url) => {
//   const filename = url.split("/").pop();
//   const response = await axios.get(`/static${url}`, { responseType: "blob" });
//   const contentType = response.headers["content-type"];
//   const fileBlob = response.data;
//   const fileFile = new File([fileBlob], filename, { type: contentType });
//   return {
//     file: fileFile,
//     downloadInfo: [fileBlob, filename, contentType],
//   };
// };

export const downloadBlobFile = (urlOrByteFile, filename, type) => {
  if (urlOrByteFile) {
    makeBrowserDownload(urlOrByteFile, filename, type);
  }
};
